/**
 * 积分"电量式百分比"模型（团队治理与计费规范 §6）。
 *
 * 设计动机：不向用户暴露绝对积分数（避免跨软件比价焦虑），改用剩余百分比进度条——
 * 套餐基础 = 100%（主色），额外赠送按占基础的比例叠加（醒目色），**按序消耗（先扣赠送、再扣基础）**。
 * 纯函数、可测；UI（进度条）在计费板块落地时接入。真实积分/扣费以服务器权威核算。
 */

export interface CreditGauge {
  /** 剩余基础积分占基础的百分比（0–100） */
  basePct: number;
  /** 剩余赠送积分占基础的百分比（叠加在 100% 之外，如 10 → 共 110%） */
  bonusPct: number;
  /** 合计百分比（basePct + bonusPct） */
  totalPct: number;
  /** 是否已耗尽 */
  exhausted: boolean;
}

function clampPct(n: number): number {
  return Math.max(0, Math.min(100, Math.round(n)));
}

/**
 * 计算电量式百分比。
 * @param total 套餐基础积分
 * @param bonus 额外赠送积分
 * @param used  已消耗（按序：**先扣赠送、再扣基础**）
 */
export function creditGauge(total: number, bonus: number, used: number): CreditGauge {
  const t = Math.max(0, total);
  const b = Math.max(0, bonus);
  const u = Math.max(0, used);
  const usedBonus = Math.min(u, b); // 先消耗赠送
  const usedBase = Math.max(0, u - b); // 赠送用完后才动基础
  const remainBonus = b - usedBonus;
  const remainBase = t - usedBase;
  const basePct = t > 0 ? clampPct((remainBase / t) * 100) : 0;
  // 赠送相对基础的百分比（可 >0 叠加到 100% 之外）；无基础时赠送按满格显示
  const bonusPct = t > 0 ? Math.max(0, Math.round((remainBonus / t) * 100)) : b > 0 ? 100 : 0;
  return {
    basePct,
    bonusPct,
    totalPct: basePct + bonusPct,
    exhausted: u >= t + b,
  };
}
